import { createReducer } from '../../../store.model';

import { ActionType } from './ca-analysis-dialog.action';
import {
    CaAnalysisDialogState,
    defaultState,
} from './ca-analysis-dialog.state';
import { ChangeTranscriptStatus } from './state/change-transcript-status.action';
import { changeTranscriptStatusReducer } from './state/change-transcript-status.reducer';
import { MinMax } from './state/min-max.action';
import { minMaxReducer } from './state/min-max.reducer';
import { ReceiveMeetingRequestContext } from './state/receive-meeting-request-context.action';
import { receiveMeetingRequestContextReducer } from './state/receive-meeting-request-context.reducer';
import { ReceiveResultData } from './state/receive-result-data.action';
import { receiveResultDataReducer } from './state/receive-result-data.reducer';
import { RememberStatusChange } from './state/remember-status-change.action';
import { rememberStatusChangeReducer } from './state/remember-status-change.reducer';
import { Reset } from './state/reset.action';
import { resetReducer } from './state/reset.reducer';

const { builder, reducer } = createReducer<ActionType, CaAnalysisDialogState>(
    defaultState(),
);

builder.add<MinMax>(ActionType.COACHING__CA__MIN_MAX, minMaxReducer);

builder.add<Reset>(ActionType.COACHING__CA__RESET, resetReducer);

builder.add<RememberStatusChange>(
    ActionType.COACHING__CA__REMEMBER_STATUS_CHANGE,
    rememberStatusChangeReducer,
);

builder.add<ChangeTranscriptStatus>(
    ActionType.COACHING__CA__CHANGE_TRANSCRIPT_STATUS,
    changeTranscriptStatusReducer,
);

builder.add<ReceiveMeetingRequestContext>(
    ActionType.COACHING__CA__RECEIVE_MEETING_REQUEST_CONTEXT,
    receiveMeetingRequestContextReducer,
);

builder.add<ReceiveResultData>(
    ActionType.COACHING__CA__RECEIVE_RESULT_DATA,
    receiveResultDataReducer,
);

export const caAnalysisDialogReducer = reducer;
